PJQ.views.meetings.MeetingsList = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.MEETINGS, 'meetings-list'),
        subTemplates: {
            comments: new PJQ.templating.Template(PJQ.constants.modules.ACTIONITEMS, 'Action-Item-Comments'),
            contactBadge: new PJQ.templating.Template(PJQ.constants.modules.GLOBAL, 'Contacts-Select-Input-Contacts'),
            meeting: new PJQ.templating.Template(PJQ.constants.modules.MEETINGS, 'meeting'),
        },
        meetingId: null
    },
    events: {
        'shown.bs.collapse .meeting-collapse': 'meetingExpanded',
        'hidden.bs.collapse .meeting-collapse': 'meetingCollapsed',
        'click .btn-settings': 'editSettings',
        'keyup .meeting-search': 'searchChanged',
        'click .clear-filters': 'clearFilters',
        'click .btn-add-meeting': 'addMeetingClicked',
        'click .btn-delete-meeting': 'deleteMeetingClicked',
        'click .btn-view-meeting': 'viewMeetingClicked',
        'click .meeting-dropdown': 'meetingClicked',
        'click .btn-follow-up': 'followUpMeetingClicked',
        'click .btn-import-template': 'importTemplate',
        'click .btn-save-a-template': 'saveTemplate'
    },
    beforeFirstRender: async function () {
        this.isFetched = false;
        this.options.project = this.options.project ? this.options.project : PJQ.app.session.project;

        this.expandedMeetings = [];
        if (this.collection == null && PJQ.app.session.project) {
            this.collection = new PJQ.collections.meetings.Meetings(null, {
                projectId: PJQ.app.session.project.id
            });
        }
        this.isFetched = false;

        if (!this.collection.isFetched && this.options.project) {
            await this.collection.fetch();
        }
        this.originMeetings = this.collection.getOriginMeetings();

        this.isFetched = true;
        this.render();
    },
    beforeRender: function () {
        if (!this.isFetched)
            return;

        if (this.options.project) {
            this.options.canEdit = PJQ.app.session.project.hasPermission('meetings.isAdmin');
            this.options.canAdd = PJQ.app.session.project.hasPermission('meetings.canAdd');
            this.options.isAdmin = PJQ.app.session.project.hasPermission('meetings.isAdmin');
            this.options.canDelete = this.options.isAdmin;
        } else {
            this.options.canEdit = true;
            this.options.canAdd = true;
            this.options.isAdmin = true;
            this.options.canDelete = true;
        }
    },
    renderData: function () {
        return {
            isFetched: this.isFetched,
            meetings: this.collection,
            originMeetings: this.originMeetings,
            canEdit: this.options.canEdit,
            canAdd: this.options.canAdd,
            isAdmin: this.options.isAdmin,
            project: PJQ.app.session.project
        };
    },
    afterRender: function () {
        if (!this.isFetched)
            return;

        new PJQ.inputs.Selectpicker({
            el: this.$('.meeting-status-filter'),
            defaultValue: null,
            isIntChoices: true,
            isMultiple: true,
            noneSelectedText: 'No Filters',
            onChange: _.bind(function (value) {
                this.statusFilter = value;
                this.renderMeetings();
            }, this)
        });

        if (this.options.meetingId > 0) {
            let initMeeting = this.collection.get(this.options.meetingId);
            if (initMeeting != null) {
                this.viewMeeting(initMeeting);
                this.options.meetingId = null;
            }
        }

        this.renderMeetings();
    },
    meetingCollapsed: function (e) {
        let $target = $(e.currentTarget),
            cid = $target.data('cid'),
            meeting = this.collection.get(cid),
            originId = meeting.get('originMeetingId') > 0 ? meeting.get('originMeetingId') : meeting.id;
        this.expandedMeetings = _.without(this.expandedMeetings, originId);
    },
    meetingExpanded: function (e) {
        let $target = $(e.currentTarget),
            cid = $target.data('cid'),
            meeting = this.collection.get(cid),
            originId = meeting.get('originMeetingId') > 0 ? meeting.get('originMeetingId') : meeting.id;
        if (this.expandedMeetings.indexOf(originId) === -1) {
            this.expandedMeetings.push(originId);
        }
    },
    searchChanged: function (e) {
        this.search = $(e.currentTarget).val();
        this.renderMeetings();
    },
    clearFilters: function () {
        this.search = '';
        this.statusFilter = null;
        this.render();
    },
    renderMeetings: function () {
        let $meetings = this.$('.meetings-container');
        $meetings.empty();

        let meetings = this.originMeetings.models;
        if (_.size(this.search) > 0 || _.size(this.statusFilter) > 0) {
            let filteredMeetings = this.collection.models;
            if (_.size(this.search) > 0) {
                filteredMeetings = _.filter(filteredMeetings, _.bind(function (meeting) {
                    if ((meeting.get('number') + ' ' + meeting.get('name') + ' ' + meeting.get('description')).toLowerCase().indexOf(this.search.toLowerCase()) !== -1) {
                        return true;
                    }
                }, this));
            }

            if (_.size(this.statusFilter) > 0) {
                filteredMeetings = _.filter(filteredMeetings, _.bind(function (meeting) {
                    if (this.statusFilter.indexOf(meeting.get('statusId')) !== -1) {
                        return true;
                    }
                }, this));
            }

            let filteredOriginMeetingIds = _.uniq(_.map(filteredMeetings, function (meeting) {
                return meeting.get('originMeetingId') > 0 ? meeting.get('originMeetingId') : meeting.id;
            }));
            meetings = _.filter(meetings, function (meeting) {
                return filteredOriginMeetingIds.indexOf(meeting.id) !== -1;
            })
        }

        if (_.size(meetings) === 0) {
            $meetings.append(`<div class="wd-100 d-flex" style="height: 80%">
                    <div class="mb-auto mt-auto wd-100 text-align-center d-flex flex-column justify-content-center align-content-center text-muted">
                        <div class="fs-24">
                            No meetings found matching your search
                        </div>
                    </div>
                </div>`)
        }

        _.each(meetings, _.bind(function (meeting) {
            this.renderSubTemplate(true, this.options.subTemplates.meeting, $meetings, {
                expandedMeetings: this.expandedMeetings,
                meetings: this.collection,
                originMeetings: this.originMeetings,
                meeting: meeting,
                canEdit: this.options.canEdit,
                canAdd: this.options.canAdd,
                isAdmin: this.options.isAdmin,
                project: PJQ.app.session.project
            }, _.bind(function (el) {
                meeting.dataTable = new PJQ.views.meetings.MeetingListDatatable({
                    el: el.find(".meeting-" + meeting.cid + "-table"),
                    rowId: "cid",
                    data: meeting.followUpMeetings.models,
                    canViewMeetings: true,
                    canDeleteMeetings: this.options.isAdmin,
                    onPageSizeChange: function (value) {

                    },
                    isAdmin: true,
                    headerData: _.bind(function () {
                        return {
                            project: this.options.project,
                            canAdd: this.options.canEdit,
                            isAdmin: this.options.isAdmin
                        };
                    }, this),
                    onRowDoubleClick: _.bind(function (row) {
                        this.viewMeeting(row.data());
                    }, this),
                    contextMenuOptions: {
                        actions: [
                            {
                                name: 'View',
                                onClick: _.bind(function (row) {
                                    this.viewMeeting(row.data());
                                }, this)
                            },
                            {
                                name: 'Delete',
                                isDanger: true,
                                onClick: _.bind(function (row) {
                                    this.deleteMeeting(row);
                                }, this),
                                isShown: _.bind(function (row) {
                                    let targetMeeting = row.data(),
                                        originMeetingId = targetMeeting.get('originMeetingId'),
                                        originMeeting = originMeetingId ? this.collection.get(originMeetingId) : targetMeeting,
                                        mostRecentMeeting = originMeeting ? _.max(originMeeting.followUpMeetings.models, function (model) {
                                            return model.id;
                                        }) : null;

                                    return mostRecentMeeting === targetMeeting && this.options.isAdmin;
                                }, this)
                            }
                        ]
                    }
                });


                meeting.dataTable.setFilter('status', this.statusFilter);
                if (_.size(this.search) > 0) {
                    meeting.dataTable.search(this.search.toLowerCase());
                }
            }, this));
        }, this));
    },
    meetingClicked: function (e) {
        let dropdown = $(e.currentTarget),
            collapse = dropdown.next('.collapse'),
            caret = dropdown.find('.meeting-caret')
        if (!collapse.hasClass('show')) {
            caret.find('i').removeClass('fa-caret-right').addClass('fa-caret-down')
        } else {
            caret.find('i').removeClass('fa-caret-down').addClass('fa-caret-right')
        }
    },
    saveTemplate: function () {
        new PJQ.views.meetings.MeetingTemplateCreatorModal({
            collection: this.collection,
            project: PJQ.app.session.project
        });
    },
    importTemplate: function () {
        new PJQ.views.meetings.ImportTemplateModal({
            project: PJQ.app.session.project,
            onImport: _.bind(function (meetings) {
                this.collection = meetings;
                this.originMeetings = this.collection.getOriginMeetings();
                this.render();
            }, this)
        });
    },
    followUpMeetingClicked: function (e) {
        e.stopPropagation();
        let target = $(e.currentTarget),
            dropdown = target.closest('.meeting-dropdown'),
            cid = dropdown.data('cid'),
            originMeeting = this.collection.get(cid),
            previousMeeting = _.max(originMeeting.followUpMeetings.models, function (model) {
                return model.id;
            });

        // We want to carry over the attendees from the previous meeting, so we have to fetch the previous meeting.
        previousMeeting.fetch({
            success: _.bind(function (previousMeeting) {
                // Need to reset the attendance from previous meeting
                if (previousMeeting.get('attendees') != null) {
                    _.each(previousMeeting.get('attendees'), (attendee) => {
                        attendee.isPresent = false;
                        attendee.isAbsent = false;
                        attendee.isDistribution = false;
                    });
                }

                followUpMeeting = new PJQ.models.meetings.Meeting({
                    originMeetingId: originMeeting.get('id'),
                    number: _.size(originMeeting.followUpMeetings) + 1,
                    startTime: previousMeeting.get('startTime'),
                    endTime: previousMeeting.get('endTime'),
                    name: previousMeeting.get('name'),
                    description: previousMeeting.get('description'),
                    attendeeIds: previousMeeting.get('attendeeIds'),
                    attendees: previousMeeting.get('attendees'),
                    projectId: PJQ.app.session.project ? PJQ.app.session.project.id : null,
                    templateId: previousMeeting.get('templateId'),
                    statusId: PJQ.constants.meetings.meetingStatus.DRAFT
                })
                this.viewMeeting(followUpMeeting);
            }, this)
        })
    },
    addMeetingClicked: function (e) {
        let meeting = new PJQ.models.meetings.Meeting({
            projectId: PJQ.app.session.project ? PJQ.app.session.project.id : null,
            templateId: this.options.templateId,
            statusId: PJQ.constants.meetings.meetingStatus.DRAFT,
            number: 1
        })

        this.viewMeeting(meeting);
    },
    editSettings: function () {
    },
    viewMeetingClicked: function (e) {
        // let row = this.dataTable.getRow((e.currentTarget).closest('tr'));
        // this.viewMeeting(row.data());
        let cid = $(e.currentTarget).data('cid'),
            meeting = this.collection.get(cid);
        if (meeting) {
            this.viewMeeting(meeting);
        }
    },
    viewMeeting: function (meeting) {
        let originMeeting = meeting.get('originMeetingId') ? this.collection.get(meeting.get('originMeetingId')) : meeting,
            mostRecentMeeting = originMeeting && originMeeting.followUpMeetings ? _.max(originMeeting.followUpMeetings.models, function (model) {
                return model.id;
            }) : meeting;
        new PJQ.views.meetings.MeetingEditModal({
            model: meeting,
            meetings: this.collection,
            isMostRecentMeeting: mostRecentMeeting === meeting || meeting.isNew(),
            onDelete: _.bind(function () {
                this.renderMeetings();
            }, this),
            onSave: _.bind(function (model, isNew) {
                let originMeeting = model.get('originMeetingId') ? this.originMeetings.get(model.get('originMeetingId')) : model;
                if (isNew) {
                    this.collection.add(model);
                    if (originMeeting !== model) {
                        originMeeting.followUpMeetings.add(model);
                    } else {
                        model.followUpMeetings = new PJQ.collections.meetings.Meetings(model);
                        this.originMeetings.add(model);
                    }
                }
                if (_.size(this.collection) <= 1) {
                    this.render();
                } else {
                    this.renderMeetings();
                }
            }, this)
        });
    },
    deleteMeetingClicked: function (e) {
        let target = $(e.currentTarget),
            cid = target.data('cid'),
            meeting = this.collection.get(cid),
            originMeeting = meeting.get('originMeetingId') ? this.collection.get(meeting.get('originMeetingId')) : meeting,
            row = originMeeting.dataTable.getRow(cid);

        this.deleteMeeting(row);
    },
    deleteMeeting: function (row) {
        if (row != null) {
            let meeting = row.data();
            if (meeting != null) {
                let originMeeting = this.collection.get(meeting.get('originMeetingId')),
                    dataTable = originMeeting ? originMeeting.dataTable : meeting.dataTable;

                new PJQ.views.modals.DeleteCancel({
                    header: "Delete Meeting",
                    body: "Are you sure you want to delete this Meeting?",
                    onDelete: _.bind(function () {
                        meeting.destroy({
                            success: _.bind(function () {
                                this.renderMeetings();
                                if (typeof this.options.onDelete === 'function') {
                                    this.options.onDelete(meeting);
                                }
                            }, this)
                        });
                    }, this)
                });
            }
        }
    }
});